import { type as types } from "../types/index";

const initialState = {isPostCotiza: false, postCotiza: null};

export const PostCotizaReducer = (state = initialState, action) => {

    const {type, payload } = action;
    
    switch (action.type) {
        case types.getPostCotiza:
            const result = {
                ...state, 
                isPostCotiza: true,
                postCotiza: payload
            };
            return result;
        case types.getPostCotizaFail:
            return {
                ...state,
                isPostCotiza: false,
                postCotiza: null
            }
        case types.resetPostCotiza:
            return {
                ...state,
                isPostCotiza: false,
                postCotiza: null
            };
        default:
            return state;
    }
}
